import { makeQuery } from 'shared/utilities';
import { IUserModel } from "shared/models";

type RequestType = {
    items: {
        userId: number,
        spaceId: number
    }[]
}

type ResponseType = {
    items: IUserModel[]
};

export const spaceUsersInsertQuery = async function (request: RequestType) {
    return await makeQuery<ResponseType>('/space-users/insert', {
        prefix: 'task-tracker',
        json: request
    });
}
